
import React, { useEffect, useState, useContext } from 'react'
import { Col, Container, FormControl, InputGroup, Row } from 'react-bootstrap'
import '../css/login.css'
import '../css/font.css'
import { useNavigate } from 'react-router-dom';
import GlobalContext from '../GlobalContext';
import defaultPalettes from '../Palettes';
import ServiceContext from '../ServiceContext';
import TextContext from '../TextContext';
import Logo512 from '../img/logo512.png'
import Logo512Testo from '../img/logo512Testo.png'
import NACweblogo from '../img/logonacweb.png'
import moment from 'moment-timezone';
import CalendarContext from '../CalendarContext';

const defCategories = [
  {
    ID: 0,
    cat_name: "nocategory",
    cat_apt: 0,
    cat_color: "#ff00ff",
    loaded: true
  }
]


const Login = () => {

  const [username, setUsername] = useState()
  const [password, setPassword] = useState()
  const [loginError, setLoginError] = useState(false)
  const globalContext = useContext(GlobalContext)
  const serviceContext = useContext(ServiceContext)
  const textContext = useContext(TextContext)
  const calendarContext=useContext(CalendarContext)
  const navigate = useNavigate()

  const sendLogin = async () => {

    const resp = await fetch(`${globalContext.get.backendUrl}/login/`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ username: username, password: password })
    })

    const respValue = await resp.json()

    if (resp.status == 200) {
      loadData()
      setLoginError(false)
    }
    else {
      setLoginError(true)
    }
  }
  const loadData = async () => {
    //console.log(serviceContext)
    // serviceContext.set(draft => { draft.Load.isLoading = draft.Load.isLoading + 1 })
    // let resp = await fetch(`${globalContext.get.backendUrl}/papiv1/categorys`, {
    //   method: 'GET',
    //   credentials: 'include'
    // })
    // let respValue = await resp.json()

    // if (resp.status == 200) {
    //   globalContext.set(draft => { draft.categories = defCategories.concat(respValue.data) })
    // }

    // resp = await fetch(`${globalContext.get.backendUrl}/papiv1/customers`, {
    //   method: 'GET',
    //   credentials: 'include'
    // })
    // respValue = await resp.json()

    // if (resp.status == 200) {
    //   globalContext.set(draft => { draft.customers = respValue.data })
    // }

    // resp = await fetch(`${globalContext.get.backendUrl}/papiv1/users`, {
    //   method: 'GET',
    //   credentials: 'include'
    // })
    // respValue = await resp.json()

    // if (resp.status == 200) {
    //   const user = {
    //     ID: respValue.data.ID,
    //     use_username: respValue.data.use_username,
    //     use_message: respValue.data.use_message,
    //     use_language: respValue.data.use_language,
    //     use_message_time: respValue.data.use_message_time,
    //     use_calendar_start: respValue.data.use_calendar_start,
    //     use_calendar_end: respValue.data.use_calendar_end,
    //     use_calendar_hour_format: respValue.data.use_calendar_hour_format,
    //     use_round_corner: respValue.data.use_round_corner,
    //     use_palette_ID: respValue.data.use_palette_ID,
    //     use_palette_name: respValue.data.use_palette_name,
    //     use_last_read: respValue.data.use_last_read,
    //     use_gapi_logged: respValue.data.use_gapi_logged,
    //     Palettes: respValue.data.Palettes,
    //     Groups: respValue.data.UserGroups.map(ug => ug.Group)
    //   }
    //   //console.log(user)
    //   if (user.use_palette_ID) {
    //     const Theme = {
    //       name: respValue.data.Palettes.filter(pal => pal.ID == user.use_palette_ID)[0].pal_name,
    //       palette: [
    //         respValue.data.Palettes.filter(pal => pal.ID == user.use_palette_ID)[0].color_1,
    //         respValue.data.Palettes.filter(pal => pal.ID == user.use_palette_ID)[0].color_2,
    //         respValue.data.Palettes.filter(pal => pal.ID == user.use_palette_ID)[0].color_3,
    //         respValue.data.Palettes.filter(pal => pal.ID == user.use_palette_ID)[0].color_4,
    //         respValue.data.Palettes.filter(pal => pal.ID == user.use_palette_ID)[0].color_5,
    //         respValue.data.Palettes.filter(pal => pal.ID == user.use_palette_ID)[0].color_6,
    //         respValue.data.Palettes.filter(pal => pal.ID == user.use_palette_ID)[0].color_7,
    //       ],
    //       text_font: respValue.data.Palettes.filter(pal => pal.ID == user.use_palette_ID)[0].Font.fon_text,
    //       title_font: respValue.data.Palettes.filter(pal => pal.ID == user.use_palette_ID)[0].Font.fon_title,
    //       text_size: respValue.data.Palettes.filter(pal => pal.ID == user.use_palette_ID)[0].Font.fon_size,
    //     }
    //     //console.log("shops", respValue.data.Shops)
    //     globalContext.set(draft => { draft.User = user; draft.Shop = respValue.data.Shop; draft.shops = respValue.data.Shops; draft.selectedShop = respValue.data.Shop; draft.Theme = Theme; })
    //   } else {
    //     //console.log("shops", respValue.data.Shops)
    //     globalContext.set(draft => { draft.User = user; draft.Shop = respValue.data.Shop; draft.shops = respValue.data.Shops; draft.selectedShop = respValue.data.Shop; draft.Theme = defaultPalettes.filter(pal => pal.name == user.use_palette_name)[0] })
    //   }

    //   if (user.use_language) {
    //     textContext.set(draft => { draft.activeLang = user.use_language })
    //   } else {
    //     textContext.set(draft => { draft.activeLang = respValue.data.Shop.sho_language })
    //   }
    // }

    // resp = await fetch(`${globalContext.get.backendUrl}/papiv1/agencys`, {
    //   method: 'GET',
    //   credentials: 'include'
    // })
    // respValue = await resp.json()

    // if (resp.status == 200) {
    //   globalContext.set(draft => { draft.Agency = respValue.data })
    // }
    // resp = await fetch(`${globalContext.get.backendUrl}/papiv1/openings`, {
    //   method: 'GET',
    //   credentials: 'include'
    // })
    // respValue = await resp.json()

    // if (resp.status == 200) {
    //   globalContext.set(draft => { draft.openings = respValue.data })
    //   calendarContext.set(draft=>{draft.resetOpenDates=true})
    // }

    // globalContext.set(draft => { draft.loaded = true; draft.Reloads.events = true })

    // serviceContext.set(draft => { draft.Load.isLoading = draft.Load.isLoading - 1 })
    
    navigate('/calendar')
  }
  const checkLogged = async () => {
    const res = await isLogged()
    if (res) {
      navigate('/calendar')
    }
  }
  const isLogged = async () => {
    const resp = await fetch(`${globalContext.get.backendUrl}/login`, {
      method: 'GET',
      credentials: 'include',
    })
    const respValue = await resp.json()

    if (resp.status == 200) {
      return true
    } else {
      return false
    }
  }

  useEffect(() => {
    checkLogged()
  }, [])


  return (
    <Container className='d-flex justify-content-center login-container ' fluid>
      <Container className='login-box'>
        <Col className='login-image'>
          {/* <p className='login-image-title'>Organizza il tuo tempo,</p> */}
          <img className='login-image-image unselectable' draggable={false} onDragStart={false} src={Logo512Testo}  />
          {/* <p className='login-image-subtitle'>Crea il tuo successo.</p> */}
          <p className='login-image-nacweb'>Ideato e realizzato da</p>
          <img onClick={()=>window.open('https://nacweb.ch', "_blank", "noreferrer")} draggable={false} onDragStart={false} className='login-image-naclogo unselectable' src={NACweblogo} />
        </Col>
        <form className='login-form'>
            <Row className='login-title'>
              {parseInt(moment().format('HH'))>=16?'Buonasera':'Buongiorno'}
            </Row>
            <Row className='login-subtitle'>
              Accedi per utilizzare l'agenda
            </Row>
            <Row style={{width: '55%'}}>
              <input
                type='text'
                placeholder='Username'
                className='input-field'
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </Row>
            <Row style={{width: '55%'}} className='mt-4'>
                <input
                  type='password'
                  placeholder='Password'
                  className='input-field'
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
            </Row>
            <Row className='mt-1 d-flex justify-content-center'>
              {loginError && (<p style={{ color: '#f00' }}>Username o password errati</p>)}
            </Row>
            <Row style={{width: '55%'}} className='mt-4 d-flex justify-content-center'>
                <button className='login-button'  onClick={(e) => { e.preventDefault(); setLoginError(false); sendLogin() }}> Login </button>
            </Row>
        </form>
        
        <span className='privacy-box' onClick={()=>{navigate('/privacy_policy')}} >
          Privacy Policy
        </span>
      </Container>


    </Container>
  )
}

export default Login